import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          setting: {
            tabs: {
              main_data: {
                tab_name: 'TAB_NAME',
                name: 'MAIN_NAME',
                surname: 'MAIN_SURNAME',
                username: 'MAIN_USERNAME',
                birthday: 'MAIN_BIRTHDAY',
                site_url: 'MAIN_SITE_URL',
                role: 'MAIN_ROLE',
                chief: 'MAIN_CHIEF',
                department: 'MAIN_DEPARTMENT',
                cannot_edit_department_info: 'MAIN_DEPARTMENT_INFO',
                about_affiliate: 'OFFER_ABOUT',
                admin_note: 'MAIN_ADMIN_NOTE',
                mfa_enabled_label: 'MAIN_MFA_ENABLED_LABEL',
                mfa_enabled: 'MAIN_MFA_ENABLED',
                mfa_disabled: 'MAIN_MFA_DISABLED',
                status: {
                  header: 'MAIN_STATUS_LABEL',
                  banned: 'MAIN_STATUS_BANNED',
                  unbanned: 'MAIN_STATUS_UNBANNED',
                  owner: 'MAIN_STATUS_OWNER',
                },
              },
            },
          },
        },
      },
    },
  }));
}
